export default {
  props: {
    embedlyThumbnailUrl: {
      type: String,
      required: true
    }
  },

  computed: {
    // Extract root url which is 'url' param of the full thumbnail url
    thumbnailRootUrl() {
      if (this.embedlyThumbnailUrl) {
        const fullUrl = new URL(this.embedlyThumbnailUrl)
        return fullUrl.searchParams.get('url')
      }
      return null
    },

    proxiedThumbnailUrl() {
      const tokyoHost = window.Agra.Configuration.tokyoUrlBase
      return `${tokyoHost}/cached_url/embedly_thumbnail?url=${encodeURIComponent(this.thumbnailRootUrl)}`
    }
  }
}
